import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_cloudtrading.png",
      alt: "Estratégias Cloud Trading",
    },
    title: "Resultados Consistente com Meta-Heurística",

    // String ou array de strings
    text: "Nossa estratégia utiliza meta-heurísticas que são algoritmos estocásticos iterativos, que progridem em direção a um ótimo global, ou seja, o extremo global de uma função, por amostragem de uma função objetivo. Eles se comportam como algoritmos de busca, tentando aprender as características do mercado para encontrar uma aproximação da melhor solução.",
    testimonial: {
      text: [
        "A Meta-Heurística pode proporcionar a consistência que você tanto procura!",
      ],
      author: {
        name: "Cleiton Oliveira, CEA (Especialista em Investimentos - ANBIMA) - Ciência da Computação e autor do livro O Poder do Método - editora Alta Books",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Meta-Heurística de Mini-índice",
    heading: "Estratégias Validadas e Consistentes",
    subtitle: ["Impulsione seus investimentos de forma simples e inteligente!"],
  },

  cta: {
    title: "Pronto para obter ganhos consistentes?",
    subtitle: "Ative agora mesmo o Meta-Heurística de mini-índice",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Cloud Trading",
    col1: [
      "A Cloud Trading possui mais de 10 anos de experiência no mercado financeiro e conta com investidores e estrategistas experientes que efetivamente entregam resultados consistentes.",
    ],
    col2: [
      "Conta com tecnologias exclusivas e automatização de estratégias com foco no mercado financeiro para ajudar o investidor a alcançar o sucesso em seus investimentos.",
    ],
  },

  stats: {
    title: "Alguns números da Cloud Trading",
    subtitle: "Números que fazem a diferença!",
    data: [
      {
        value: "+10",
        description:
          "Anos de atividade na área financeira ajudando investidores a atingirem melhores resultados",
      },
      {
        value: "+30",
        description: "Estratégias em operação",
      },
      {
        value: "+75%",
        description:
          "das negociações com lucros nas estratégias Meta-Heurística",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por que utilizar o nosso Meta-Heurística?",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.clock,
        title: "Liberdade de Tempo",
        description:
          "Por meio da nossa estratégia você pode investir de qualquer lugar e em qualquer hora e isso lhe proporcionará o ganho do nosso bem mais precioso - O tempo.",
      },
      {
        icon: iconsSet.calendar,
        title: "Período de teste gratuito",
        description:
          "Você pode testar nossa estratégia gratuitamente por um período e conferir a performance da nossa meta-heurística em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "Desenvolvimento",
        description:
          "A essência da estratégia é baseada nos conceitos do Dr. Alexander Elder que é considerado o “papa” da análise técnica.",
      },
      {
        icon: iconsSet.update,
        title: "Estratégia Atemporal",
        description:
          "Fizemos uma análise robusta dos dados para lhe apresentar uma 'carteira ótima' e atemporal (nossa meta-heurística se adapta a qualquer cenário).",
      },
      {
        icon: iconsSet.memory,
        title: "Processamento",
        description:
          "Os nossos meta-heurísticos  conseguem realizar milhares de cálculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        icon: iconsSet.growth,
        title: "Consistência",
        description:
          "Estratégias automatizadas, testadas, validadas e com consistência de mais de 8 anos.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos Cloud Trading.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
